import { AgencyList } from '../interface/agency-list';

export interface AddWaitlistAgency {
  agencyLocationSk: string;
  agencySk: string;
}

export interface AddWaitlistData {
  selectedStudents: string[];
  selectedAgency: AgencyList[];
}

export class AddWaitlistModel {
  studentSks: string[];
  agencys: AddWaitlistAgency[];
  isActive: boolean;
  constructor(data: AddWaitlistData) {
    this.studentSks = data?.selectedStudents;
    this.agencys = data.selectedAgency.map((item: AgencyList) => ({
      agencyLocationSk: item.agencyLocationSk,
      agencySk: item.agencySk,
    }));
    this.isActive = true;
  }
}
